var map = {
	"./ActiveCustomer.vue": "./src/modules/shop/src/components/ActiveCustomer.vue",
	"./ActiveRestaurantAdmin.vue": "./src/modules/shop/src/components/ActiveRestaurantAdmin.vue",
	"./AdminOrderSummary.vue": "./src/modules/shop/src/components/AdminOrderSummary.vue",
	"./Breadcrumbs.vue": "./src/modules/shop/src/components/Breadcrumbs.vue",
	"./ButtonAddToCart.vue": "./src/modules/shop/src/components/ButtonAddToCart.vue",
	"./BuyInStock.vue": "./src/modules/shop/src/components/BuyInStock.vue",
	"./CardIteratorStockItems.vue": "./src/modules/shop/src/components/CardIteratorStockItems.vue",
	"./CardList.vue": "./src/modules/shop/src/components/CardList.vue",
	"./CardListCategories.vue": "./src/modules/shop/src/components/CardListCategories.vue",
	"./CardListFavouriteItems.vue": "./src/modules/shop/src/components/CardListFavouriteItems.vue",
	"./CardListStockItems.vue": "./src/modules/shop/src/components/CardListStockItems.vue",
	"./CartItemCard.vue": "./src/modules/shop/src/components/CartItemCard.vue",
	"./CategoryCardList.vue": "./src/modules/shop/src/components/CategoryCardList.vue",
	"./CompleteSalesOrders.vue": "./src/modules/shop/src/components/CompleteSalesOrders.vue",
	"./CustomerArea.vue": "./src/modules/shop/src/components/CustomerArea.vue",
	"./CustomerLocationTimes.vue": "./src/modules/shop/src/components/CustomerLocationTimes.vue",
	"./CustomerName.vue": "./src/modules/shop/src/components/CustomerName.vue",
	"./DeliveryAddress.vue": "./src/modules/shop/src/components/DeliveryAddress.vue",
	"./DeliveryAddresses.vue": "./src/modules/shop/src/components/DeliveryAddresses.vue",
	"./DesktopShopHome.vue": "./src/modules/shop/src/components/DesktopShopHome.vue",
	"./DialogAddSalesOrderLine.vue": "./src/modules/shop/src/components/DialogAddSalesOrderLine.vue",
	"./DisplayUsers.vue": "./src/modules/shop/src/components/DisplayUsers.vue",
	"./DivisionFilter.vue": "./src/modules/shop/src/components/DivisionFilter.vue",
	"./Favourite.vue": "./src/modules/shop/src/components/Favourite.vue",
	"./FavouriteIcon.vue": "./src/modules/shop/src/components/FavouriteIcon.vue",
	"./FormCategory.vue": "./src/modules/shop/src/components/FormCategory.vue",
	"./FormCostCentre.vue": "./src/modules/shop/src/components/FormCostCentre.vue",
	"./FormCustomerLocation.vue": "./src/modules/shop/src/components/FormCustomerLocation.vue",
	"./FormDelivery.vue": "./src/modules/shop/src/components/FormDelivery.vue",
	"./FormDeliveryDate.vue": "./src/modules/shop/src/components/FormDeliveryDate.vue",
	"./FormDivision.vue": "./src/modules/shop/src/components/FormDivision.vue",
	"./FormEmail.vue": "./src/modules/shop/src/components/FormEmail.vue",
	"./FormEmailLog.vue": "./src/modules/shop/src/components/FormEmailLog.vue",
	"./FormPickingList.vue": "./src/modules/shop/src/components/FormPickingList.vue",
	"./FormPickingListItem.vue": "./src/modules/shop/src/components/FormPickingListItem.vue",
	"./FormPreferredDeliveryAddress.vue": "./src/modules/shop/src/components/FormPreferredDeliveryAddress.vue",
	"./FormPurchaseLimit.vue": "./src/modules/shop/src/components/FormPurchaseLimit.vue",
	"./FormRestaurantAdmin.vue": "./src/modules/shop/src/components/FormRestaurantAdmin.vue",
	"./FormSoftSaleStockItem.vue": "./src/modules/shop/src/components/FormSoftSaleStockItem.vue",
	"./FormStockItem.vue": "./src/modules/shop/src/components/FormStockItem.vue",
	"./FormStockItemAlternative.vue": "./src/modules/shop/src/components/FormStockItemAlternative.vue",
	"./FormSupplier.vue": "./src/modules/shop/src/components/FormSupplier.vue",
	"./GlobalSearch.vue": "./src/modules/shop/src/components/GlobalSearch.vue",
	"./ImageStat.vue": "./src/modules/shop/src/components/ImageStat.vue",
	"./ImageUpload.vue": "./src/modules/shop/src/components/ImageUpload.vue",
	"./ImportFavourites.vue": "./src/modules/shop/src/components/ImportFavourites.vue",
	"./ListDeliveryDate.vue": "./src/modules/shop/src/components/ListDeliveryDate.vue",
	"./ListEmailLog.vue": "./src/modules/shop/src/components/ListEmailLog.vue",
	"./ListFavouriteItems.vue": "./src/modules/shop/src/components/ListFavouriteItems.vue",
	"./MiniCart.vue": "./src/modules/shop/src/components/MiniCart.vue",
	"./MobileButtonAddToCart.vue": "./src/modules/shop/src/components/MobileButtonAddToCart.vue",
	"./MobileFavouriteStockItem.vue": "./src/modules/shop/src/components/MobileFavouriteStockItem.vue",
	"./MobileListFavouriteItems.vue": "./src/modules/shop/src/components/MobileListFavouriteItems.vue",
	"./MobileMiniCart.vue": "./src/modules/shop/src/components/MobileMiniCart.vue",
	"./MobileShopHome.vue": "./src/modules/shop/src/components/MobileShopHome.vue",
	"./MobileStockItem.vue": "./src/modules/shop/src/components/MobileStockItem.vue",
	"./OnHoldCustomer.vue": "./src/modules/shop/src/components/OnHoldCustomer.vue",
	"./Orders.vue": "./src/modules/shop/src/components/Orders.vue",
	"./PasswordField.vue": "./src/modules/shop/src/components/PasswordField.vue",
	"./PickingSlip.vue": "./src/modules/shop/src/components/PickingSlip.vue",
	"./PrintPickingSlip.vue": "./src/modules/shop/src/components/PrintPickingSlip.vue",
	"./PrintPickingSlips.vue": "./src/modules/shop/src/components/PrintPickingSlips.vue",
	"./PrintText.vue": "./src/modules/shop/src/components/PrintText.vue",
	"./ProductCardList.vue": "./src/modules/shop/src/components/ProductCardList.vue",
	"./QuantityButton.vue": "./src/modules/shop/src/components/QuantityButton.vue",
	"./QuantityButtonBasic.vue": "./src/modules/shop/src/components/QuantityButtonBasic.vue",
	"./QuantityButtonCart.vue": "./src/modules/shop/src/components/QuantityButtonCart.vue",
	"./QuantityButtonSmall.vue": "./src/modules/shop/src/components/QuantityButtonSmall.vue",
	"./ReportProductImages.vue": "./src/modules/shop/src/components/ReportProductImages.vue",
	"./ReportSlowCustomers.vue": "./src/modules/shop/src/components/ReportSlowCustomers.vue",
	"./SalesOrderHeader.vue": "./src/modules/shop/src/components/SalesOrderHeader.vue",
	"./Search.vue": "./src/modules/shop/src/components/Search.vue",
	"./SelectUsers.vue": "./src/modules/shop/src/components/SelectUsers.vue",
	"./SoftSaleDialog.vue": "./src/modules/shop/src/components/SoftSaleDialog.vue",
	"./SoftSales.vue": "./src/modules/shop/src/components/SoftSales.vue",
	"./SoftSalesActivity.vue": "./src/modules/shop/src/components/SoftSalesActivity.vue",
	"./StatisticsCard.vue": "./src/modules/shop/src/components/StatisticsCard.vue",
	"./StockItemCard.vue": "./src/modules/shop/src/components/StockItemCard.vue",
	"./StockItemMerchandise.vue": "./src/modules/shop/src/components/StockItemMerchandise.vue",
	"./StockItemsLoading.vue": "./src/modules/shop/src/components/StockItemsLoading.vue",
	"./TableCart.vue": "./src/modules/shop/src/components/TableCart.vue",
	"./TableQuoteCart.vue": "./src/modules/shop/src/components/TableQuoteCart.vue",
	"./ViewOrderLog.vue": "./src/modules/shop/src/components/ViewOrderLog.vue",
	"./XmlAuditDialog.vue": "./src/modules/shop/src/components/XmlAuditDialog.vue"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/modules/shop/src/components sync recursive \\.vue$";